import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {TpVehicleTypeService} from 'app/blocks/service/api/tp-vehicle-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ITpVehicleType, TpVehicleType} from 'app/blocks/model/tp-vehicle-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class TpVehicleTypeResource extends AbstractEntityResource<ITpVehicleType> {
    constructor(tpVehicleTypeService: TpVehicleTypeService, router: Router) {
        super(
            Resource.TP_VEHICLE_TYPES,
            tpVehicleTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TP_VEHICLE_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TP_VEHICLE_TYPES),
            (entity?) => new TpVehicleType(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
